import type { FC } from 'react';

import cn from 'classnames';

import type { ComposerAttachablePost } from '../communityPostComposer/CommunityPostComposer.type';
import { CommunityWebPostThumbnail } from './CommunityWebPostThumbnail';

export interface CommunityWebPostEmbedCardProps {
  post: ComposerAttachablePost;
  /** Resize/CDN-rewrite hook for image URLs. Defaults to the raw URL. */
  transformImageUrl?: (url: string, width: number) => string;
  className?: string;
}

export const CommunityWebPostEmbedCard: FC<CommunityWebPostEmbedCardProps> = ({
  post,
  transformImageUrl = (url) => url,
  className,
}) => {
  return (
    <div
      className={cn(
        'bg-black/[0.03] border border-black/10 rounded-2xl p-3 flex flex-col gap-3 sm:flex-row overflow-clip',
        className,
      )}
    >
      <CommunityWebPostThumbnail
        imageUrl={post.image_url}
        logoUrl={post.publication_logo_url}
        transformImageUrl={transformImageUrl}
        className="aspect-[724/421] w-full rounded-lg shrink-0 sm:aspect-auto sm:w-[152px] sm:h-[88px]"
      />
      <div className="flex min-w-0 flex-col gap-1 sm:flex-1 sm:justify-center">
        <h4 className="line-clamp-2 text-[15px] font-semibold leading-5 tracking-[-0.15px] text-black break-words">
          {post.web_title}
        </h4>
        {post.web_subtitle && (
          <p className="hidden sm:line-clamp-2 text-[13px] leading-[18px] tracking-[-0.13px] text-black/70">
            {post.web_subtitle}
          </p>
        )}
        {post.publication_via_label && (
          <div className="flex min-w-0 items-center gap-1.5">
            {post.publication_logo_url && (
              <img
                src={transformImageUrl(post.publication_logo_url, 28)}
                alt=""
                className="size-3.5 shrink-0 rounded-[3px] object-cover"
              />
            )}
            <span className="truncate text-xs font-medium leading-4 text-black/45">{post.publication_via_label}</span>
          </div>
        )}
      </div>
    </div>
  );
};
